export const ROUTES = {
  // Auth routes
  LOGIN: '/login',
  REGISTER: '/register',
  RESET_PASSWORD: '/reset-password',
  NEW_PASSWORD: '/new-password',
  CHANGE_PASSWORD: '/change-password',
  VERIFY_CODE: '/verify-code',
  RESTORE_PWD_VERIFY_CODE: '/restore-pwd-verify-code',

  // Main routes
  DASHBOARD: '/dashboard',
  ABOUT: '/about',
  ACCESS_DENIED: '/accessDenied',
  YNA_PRO_PAYMENT: '/yna-pro-payment',
  PAYMENT_THANK_YOU: '/yna-pro-payment/thank-you',
} as const;

